import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {StoreType} from "../../../../store/spirs/types";
import {UPDATE_COUPON_MESSAGE} from "../../../../store/spirs/actions";
import {useTranslation} from "react-i18next";

export default function CouponBottomMessages() {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const {message} = useSelector((state: StoreType) => ({
        message: state.spirs.coupons.message,
        currentCouponType: state.spirs.coupons.currentCouponType,
    }));
    let eventType = "";


    useEffect(() => {
        if (!message) return;

        const timer = setTimeout(() => {
            dispatch(UPDATE_COUPON_MESSAGE(''));
        }, 10000);

        return () => clearTimeout(timer);
    }, [message]);


    return (
        <div className="pre-wrap">{message && t(message)}</div>
    );
}
